<div class="document-split-container">
  <app-thumbnail-viewer
    cdkScrollable
    mode="split"
    [thumbnails]="thumbnails()"
    [isLoading]="isLoading"
    [fileName]="fileName"
    [(selectedPages)]="selectedPages"
    (pageClicked)="togglePageSelection($event)"
    (selectedDocumentPages)="onSelectedDocumentPagesChange($event)"
  >
  </app-thumbnail-viewer>

  <aside class="split-panel">
    <div class="split-header">
      <h2 class="header-label">{{ 'documentSplit.splitDocument' | translate }}</h2>
    </div>
    <div class="split-settings">
      <h3 class="section-header">{{ 'documentSplit.rangeSettings' | translate }}</h3>
      <div class="options-container">
        <div class="range-option">
          <p-radiobutton
            class="dap-selected-pages-range"
            name="range"
            value="Selected Pages"
            inputId="selectedPages"
            [(ngModel)]="rangeSettings"
            (ngModelChange)="onRangeChange($event)"
          />
          <label
            for="selectedPages"
            class="radio-button-label ml-2"
            >{{ 'documentSplit.selectedPages' | translate }}</label
          >
        </div>
        <div class="radio-option">
          <p-radiobutton
            class="dap-all-pages-range"
            name="range"
            value="All Pages"
            inputId="allPages"
            [disabled]="isLoading"
            [(ngModel)]="rangeSettings"
            (ngModelChange)="onRangeChange($event)"
          />
          <label
            for="allPages"
            class="radio-button-label ml-2"
            >{{ 'documentSplit.allPages' | translate }}</label
          >
        </div>
      </div>
      <p-divider />
      <h3 class="section-header">{{ 'documentSplit.modeSettings' | translate }}</h3>
      <div class="options-container">
        <div class="radio-option">
          <p-radiobutton
            class="dap-merge-pages-mode"
            name="mode"
            value="Merge Pages"
            inputId="mergePages"
            [(ngModel)]="modeSettings"
          />
          <label
            for="mergePages"
            class="radio-button-label ml-2"
            >{{ 'documentSplit.splitPages' | translate }}</label
          >
        </div>
      </div>
      <p-divider />
      <div
        class="split-information"
        aria-live="polite"
        aria-atomic="true"
      >
        {{ 'documentSplit.splitMessage' | translate: { count: '[' + selectedPages.length + ']' } }}
      </div>
    </div>

    <div class="split-panel-footer">
      <p-button
        label="{{ 'done' | translate }}"
        class="dap-close-split"
        variant="text"
        [attr.aria-label]="'done' | translate"
        (click)="closeSplit()"
      ></p-button>
      <p-button
        label="{{ 'documentSplit.splitButton' | translate }}"
        class="dap-split-btn"
        severity="secondary"
        icon="fa-solid fa-file-dashed-line"
        iconPos="left"
        [disabled]="selectedPages.length < 1"
        [attr.aria-label]="'documentSplit.splitButton' | translate"
        (click)="openSplitDialog()"
      ></p-button>
    </div>
  </aside>
</div>
<p-dialog
  header="{{ 'documentSplit.splitDocument' | translate }}"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [(visible)]="isDialogVisible"
  (onHide)="closeSplitDialog()"
>
  <p class="dialog-content">
    {{
      'documentSplit.splitConfirmationMessage'
        | translate: { count: '[' + selectedPages.length + ']' }
    }}
  </p>
  <p class="confirm-message">{{ 'documentSplit.confirmSplitMessage' | translate }}</p>
  <div class="dialog-footer">
    <p-button
      class="dap-cancel-split"
      variant="text"
      [label]="'cancel' | translate"
      (onClick)="closeSplitDialog()"
    >
    </p-button>
    <p-button
      class="dap-confirm-split"
      icon="fa-solid fa-file-dashed-line"
      iconPos="left"
      [label]="'documentSplit.splitButton' | translate"
      (onClick)="splitDocument()"
    >
    </p-button>
  </div>
</p-dialog>
